import React, {useContext} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {capitalizeFirstLetters} from "../../../../../misc/helpers";
import {getCommonVisualizerType} from "../../../../../config";
import LookWizardContext from "./lookWizardContext";


const LookWizardContentDescription = (props) => {

  const {wizardActiveItem, wizardActiveStep} = props;

  const {currentGroups} = useContext(LookWizardContext);

  if (wizardActiveStep === -1) {
    return wizardActiveItem.description
  }
  if (wizardActiveStep > -1 && currentGroups.length === 1) {
    return currentGroups[0].description
  }
  if (wizardActiveStep > -1 && !currentGroups.length) {
    return <FormattedMessage id="wizard.completed.description" values={{
      wizardName: wizardActiveItem.name,
      visualizerType: capitalizeFirstLetters(getCommonVisualizerType()),
    }}/>
  }
  if (wizardActiveStep === 0 && currentGroups.length > 1 && wizardActiveItem.startDescription) {
    return wizardActiveItem.startDescription
  }
  return null
};

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep} = store.wizardState;
  return {
    wizardActiveItem,
    wizardActiveStep,
  };
};

export default connect(mapStateToProps)(LookWizardContentDescription)
